const TermCondition = [
  {
    title: 'Penerimaan Ketentuan',
    content: 'Dengan mengakses layanan Papa Kilo Hairstudio, Anda setuju untuk terikat dengan Ketentuan Layanan ini. Jika Anda tidak setuju, dilarang menggunakan layanan kami.'
  },
  {
    title: 'Layanan Kami',
    content: 'Papa Kilo Hairstudio menyediakan layanan potong, styling, pewarnaan, dan perawatan rambut. Kami berkomitmen memberikan pengalaman terbaik bagi pelanggan.'
  },
  {
    title: 'Reservasi',
    content: 'Reservasi dapat dilakukan melalui website, aplikasi, atau telepon. Kami berhak membatalkan atau mengubah jadwal jika diperlukan.'
  },
  {
    title: 'Pembayaran',
    content: 'Pembayaran dilakukan di tempat atau melalui metode yang telah ditentukan. Harga dapat berubah sewaktu-waktu tanpa pemberitahuan.'
  },
  {
    title: 'Tanggung Jawab Pengguna',
    content: 'Pengguna bertanggung jawab atas keakuratan informasi yang diberikan dan perilaku selama berada di studio.'
  },
  {
    title: 'Pembatalan dan Keterlambatan',
    content: 'Pembatalan reservasi minimal 2 jam sebelum jadwal. Keterlambatan lebih dari 15 menit dapat mengakibatkan pembatalan atau penundaan layanan.'
  }
];

export default TermCondition